require('../../core/require');
require('./page.scss');
